/* eslint-disable no-debugger */
/* eslint-disable no-param-reassign */
/* eslint-disable react/self-closing-comp */
/* eslint-disable import/named */
/* eslint-disable prefer-template */
/* eslint-disable one-var */
/* eslint-disable radix */
/* eslint-disable no-else-return */
/* eslint-disable no-shadow */
/* eslint-disable react/no-unused-prop-types */
/* eslint-disable react/prop-types */
/* eslint-disable no-unused-expressions */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable vars-on-top */
/* eslint-disable eqeqeq */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable prefer-destructuring */
/* eslint-disable no-var */
/* eslint-disable camelcase */
/* eslint-disable arrow-body-style */
/* eslint-disable no-undef */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable object-shorthand */
/* eslint-disable no-unused-vars */
/* eslint-disable no-use-before-define */
/* eslint-disable prefer-const */
/* eslint-disable dot-notation */
/* eslint-disable no-nested-ternary */
import React, { useEffect, useState, useReducer } from "react";
import { connect, useDispatch } from "react-redux";

import XLSX from "sheetjs-style";
import PropTypes, { object } from "prop-types";
import clsx from "clsx";
import moment from "moment";
// import {  } from "@material-ui/core";
import {
  Modal,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Box,
  TextField,
  Grid,
  FormGroup,
  IconButton
} from "@material-ui/core"; // Remove the unused imports for CHG0073013 
import { useHistory } from "react-router-dom";

import DeleteIcon from "@mui/icons-material/Delete";

import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import { MdReplay } from "react-icons/md";
import styles from "./BookingEReport.module.css";
import {
  CustomDatePicker,
  CustomFormGroup,
  CustomSelect,
  ValidatingTextField
} from "../FormComponents";
import {
  DATE_FORMAT,
  API_RESOURCE_URLS,
  DISPLAY_MESSAGES,
  MESSAGE_TYPE,
  RESOURCE_TYPE,
  USER_OPERATIONS,
  Regex
} from "../../constants";
import Truckloading from "../CvLoader/Cvloader";
import { setLogin } from '../../redux/features/auth/actions';
import { usePopupManager } from "../../providers/PopupManager/PopupManager";
import { AuthChecker, Button } from "../../atomicComponents";
import { withAllowedOperationsProvider } from "../../hocs";
import {

  fetchChassis,

  getInvoice
} from "../../redux/actions/productsActions";
import ReportTable from '../ReportTableComponent/ReportTable';
import { sanitizeCoCodeNumeric, sanitizeNumeric } from "../../utils/utils";
import apiService from "../../apis/apiService";


function ReportShiftUtilizationForm({
  redirectToProcessPage,
  product,
  counter,
  baseUrl,
  auth
}) {
  const ROW_HEIGHT = 38;

  const history = useHistory();

  const { userRole } = auth;
  const dispatchNew= useDispatch();
  let UserRoles = userRole;
  let SAFlag = UserRoles.includes("SA");
  let DSFlag = UserRoles.includes("DS");
 
  let requiredUsers= ["DS","SA"];
 
  const[userList,setUserList]=useState(userRole.filter(role => requiredUsers.includes(role)))
  const { showPopup } = usePopupManager();

  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [confirmModalFlag2, setConfirmModal2] = useState(false);
  const [deleteParam2, handleDeleteParam2] = useState();
  const [resetAllVisitedFields, setResetAllVisitedFields] = useState(false);
  const [highlightMandatoryFields, setHighlightMandatoryFields] =
    useState(false);
  const [tableData, setTableData] = useState([]);
  const [asnCount, setAsnCount] = useState(0);
  const [viewDisplay, setViewDisplay] = useState(false);

  const HEIGHT = '255px';
  const FILENAME = 'Booking_Efficiency_Report';

  const [myState, setState] = React.useState({
    toDate: null,
    fromDate: null,
    checkFlag: false,
    checkType4: ""
  });
  const[loadings,setLoadings]=useState(false);
  const[allTableData,setAllTableData]=useState([]);
  const[tableArray,setTableArray]=useState([]);
  
  const handleDate = (date, name) => {
    if (date == null) {
      setState((prevData) => ({ ...prevData, [name]: null }));
      return;
    }
    let newDate = date.format(DATE_FORMAT.ISO);
    let newDate2 = moment(newDate, "DD-MM-YYYY").format("DD/MM/YYYY");

    setState((prevData) => ({ ...prevData, [name]: date }));
  };

  useEffect(() => {
    setViewDisplay(true);
  }, []);

  const convert2 = (str) => {
    if (str == null) {
      return "";
    } else {
      const date = new Date(str);
      const mnth = `0${date.getMonth() + 1}`.slice(-2);
      const day = `0${date.getDate()}`.slice(-2);
      //  return [date.getFullYear(), mnth, day].join("-"); //  2022-03-29

      return [mnth, day, date.getFullYear()].join("-"); // 03/08/2022
    }
  };


  useEffect(()=>{
    if(userList?.length == 1){
      setState((prev) => ({
        ...prev,
        checkType4:userList[0]
      }));
    }
  },[userList])



  const handleSumit = async () => {
   
      let fromDate = convert2(myState.fromDate);
      let toDate = convert2(myState.toDate);
      setLoadings(true);
      if (
        myState.fromDate == "" ||
        myState.toDate == "" ||
        myState.fromDate == null ||
        myState.toDate == null
      ) {
        setLoadings(false);
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Please enter a date"
        });
        return;
      }
      if (
        myState.checkType4 == "" ||  myState.checkType4 == null 
      ) {
        setLoadings(false);
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "Please Select Role"
        });
        return;
      }

      const isSameOrAfter = moment(fromDate).isAfter(toDate);
      if (isSameOrAfter) {
        setLoadings(false);
        setTableArray([])
        setAllTableData([])
        showPopup({
          type: MESSAGE_TYPE.INFORMATION,
          contextText: MESSAGE_TYPE.INFORMATION,
          info: "End Date Should Be Greater Than  Or Equal To Start Date ",
        });
        if(userList?.length != 1){
        setState((prev) => ({
          ...prev,
          checkType4: ""
        }));
      } }else {
        let apiFormatedData = {
          pers_no: sanitizeNumeric(auth.personNumber),
          user_role: myState.checkType4,
          co_code: sanitizeCoCodeNumeric(auth.companyCode),
          dtfrom: moment(fromDate, "MM-DD-YYYY").format("YYYY-MM-DD"),
          dtto: moment(toDate, "MM-DD-YYYY").format("YYYY-MM-DD")
        };      
        let headerss = new Headers();
        headerss.append("Content-Type", "application/json");
        try {
          const response = await apiService.BookingEfficiencyReport(apiFormatedData, dispatchNew)
          dispatchNew(setLogin({...auth, recentStatus: response.status}))
          if(response.status===403){
            setLoadings(false);
           }
           if (response?.msg=="Success" && response?.data?.length != 0) {
            setLoadings(false);
            setState((prevState) => ({ ...prevState, tableFlag: true }));
            const finalList = [];
            response?.data.map((row, index) => {
              finalList.push({
                id: index,
                ...row,
              });
            });
            setAllTableData(finalList)
           
          } 
          else if(response?.msg=="Success" && response?.data?.length == 0) {
            setLoadings(false);
            setAllTableData([])
            showPopup({
              type: MESSAGE_TYPE.INFORMATION,
              contextText: MESSAGE_TYPE.INFORMATION,
              info: "No Records Found",
          })
          }
          else if(response && response?.msg=="Fail")  {
            setLoadings(false);
            setAllTableData([])
            showPopup({
              type: MESSAGE_TYPE.FAILURE,
              contextText: MESSAGE_TYPE.FAILURE,
              info: response?.data,
          })
          }
          setState((prevState) => ({ ...prevState, tableFlag: true }));
        } catch (error) {
          setLoadings(false);
          setAllTableData([])
          if (error.response) {
            showPopup({
                    type: MESSAGE_TYPE.FAILURE,
                    contextText: MESSAGE_TYPE.FAILURE,
                    info: "Oops! Something went wrong. Please try again later. Please try again later",
                })
          }
          else {
            showPopup({
                  type: MESSAGE_TYPE.INFORMATION,
                  contextText: MESSAGE_TYPE.INFORMATION,
                  info: "There might be Network issue, please try after some time",
              })
          }
        } finally{
          setLoadings(false);
        }
      }
   
  };

  const handleClose = () => setIsPopupOpen(false);

  const handleClose2 = () => setConfirmModal2(false);
  const resetFields = () => {
    if (myState.checkFlag == true) {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null
      }));
    } else {
      setState((prevData) => ({
        ...prevData,
        chassisNo: null,
        toDate: null,
        fromDate: null,
        bodyBuilder: null
      }));
    }

    setTableData([]);
    setHighlightMandatoryFields(false);
  };

  const handleCheck4 = (e) => {
    setState((prev) => ({
      ...prev,
      checkType4: e.target.value
    }));
    setAllTableData([])
    setState((prev)=>({
      ...prev,
      fromDate:null,
      toDate:null
    }))
  };

  const baseDefaultColumns = [
    {
      width: 100,
      title: "BC No",
      field: "bc",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 250,
      title: "BC Name",
      field: "bc_name",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 250,
      title: "BU",
      field: "workarea",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Month",
      field: "month",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Project Booking {A}",
      field: "project_booking_hrs",
      enableSearch: true,
      enableFilter: true
    },

    {
      width: 110,
      title: "Indirect Project Booking {B}",
      field: "indirect_project_booking_hrs",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Un-Booked hrs {C}",
      field: "unbooked_hrs",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Total {A+B+C=D}",
      field: "total_available_hrs",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 150,
      title: "Reviewed By Manager(Approved){E}",
      field: "reviewed_hrs",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 170,
      title: "Not Reviewed By Manager(Not Approved){F}",
      field: "not_reviewed_hrs",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Total {E+F=G}",
      field: "total_hrs",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Late Booking {H}",
      field: "late_booking",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Late Booking Approval {I}",
      field: "late_booking_approval",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Weekly Booking {J}",
      field: "timely_booking",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Total {H+I+J=K}",
      field: "total",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Project Booking % {A/D}",
      field: "project_percentage",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 150,
      title: "Indirect Project Booking %{B/D}",
      field: "indirect_project_percentage",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Un-Booked hrs % {C/D}",
      field: "unbooked_hrs_percentage",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 150,
      title: "Booking Efficiency {(A+B)/C}",
      field: "booking_efficency",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 180,
      title: "Reviewed By Manager(Approved) % {E/G}",
      field: "reviewed_hrs_percentage",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 200,
      title: "Not Reviewed By Manager(Not Approved) % {F/G}",
      field: "not_reviewed_hrs_percentage",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Late Booking % {H/K}",
      field: "late_booking_percentage",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 130,
      title: "Late Booking Approval % {I/K}",
      field: "late_booking_approval_percentage",
      enableSearch: true,
      enableFilter: true
    },
    {
      width: 100,
      title: "Weekly Booking % {J/K}",
      field: "timely_booking_percentage",
      enableSearch: true,
      enableFilter: true
    }
  ];

  const handleCancel = () => {
    window.location.reload();
  };

  const renderOther = () => (
    <div className={styles.formGroup}>
      {userList?.length > 1 && 
      <>
      <Grid
        container
        spacing={0}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        {SAFlag ? (
          <>
            <Grid item md={3} lg={3} sm={12}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                required={true}
                value={myState.checkType4}
                style={{
                  marginLeft: "27px",
                  marginRight: "20px"
                }}
                onChange={handleCheck4}
              >
                <FormControlLabel
                  value="SA"
                  name="status4"
                  label="Super Admin"
                  control={<Radio size="small" />}
                />
              </RadioGroup>
            </Grid>
          </>
        ) : (
          ""
        )}
        {DSFlag ? (
          <>
            <Grid item md={3} lg={3} sm={12}>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                required={true}
                value={myState.checkType4}
                style={{
                  marginLeft: "27px",
                  marginRight: "20px"
                }}
                onChange={handleCheck4}
              >
                <FormControlLabel
                  value="DS"
                  name="status4"
                  label="Departmental SPOC"
                  control={<Radio size="small" />}
                />
              </RadioGroup>
            </Grid>
          </>
        ) : (
          ""
        )}
      </Grid>
      </> 
      }
      
      <Grid
        container
        spacing={1}
        style={{ marginTop: "10px" }}
        className={styles.myGrid}
        columns={12}
      >
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>From Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                clearable
                autoOk
                inputVariant="outlined"
                value={myState.fromDate}
                onChange={(e) => {
                  handleDate(e, "fromDate");
                }}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput)
                }}
                emptyLabel="DD-MM-YYYY"
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
              />
            </div>
          </div>
        </Grid>
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <div className={clsx(styles.lableDiv)}>
              <label>To Date</label>
            </div>
            <div className={styles.formDiv}>
              <CustomDatePicker
                clearable
                autoOk
                inputVariant="outlined"
                value={myState.toDate}
                onChange={(e) => {
                  handleDate(e, "toDate");
                }}
                inputProps={{
                  className: clsx(styles.select, styles.dateInput)
                }}
                emptyLabel="DD-MM-YYYY"
                // defaultDate={moment().format(DATE_FORMAT.DD_MM_YYYY)}
                // minDate={!isEditable? null: getMinimumDateForPicker(index, milestones)}
                format="DD-MM-YYYY"
                data-testid="date-picker-div-1"
                style={{ width: "100%" }}
                // maxDate={moment().toDate()}
              />
            </div>
          </div>
        </Grid>
        <Grid item md={4} lg={4}>
          <div className={styles.rowDiv}>
            <Button
              className={clsx(styles.actionButton, styles.primaryActionButton)}
              variant="primary"
              onClick={(e) => {
                e.preventDefault();
                handleSumit();
              }}
            >
              Submit
            </Button>
            <Button
              className={clsx(styles.actionButton, styles.resetButton)}
              variant="tertiary"
              onClick={() => handleCancel()}
              data-testid="confirm-action"
              style={{ marginRight: "5px", marginLeft: "15px" }}
            >
              Cancel
            </Button>
          </div>
        </Grid>
      </Grid>
    </div>
  );

  const renderReport = () => (
    <div className={styles.formGroup}>
      <div
        className={styles.col2}
        style={{
          width: "100%",
          height: "100%"
        }}
      >
        <div className={styles.container} style={{ boxSizing: "border-box" }}>
        {allTableData?.length > 0 && 
           <ReportTable columns={baseDefaultColumns} data={allTableData} height={HEIGHT} fileName={FILENAME} />
         } 
         
        </div>
      </div>
      <div
        className={styles.col2}
        style={{
          width: "100%",
          height: "100%"
        }}
      ></div>
    </div>
  );

  const resetAllInputs = () => {
    const inputs = {
      purchaseBuyerName: "",
      suppRepresentativeName: "",
      suppRepresentativeContact: "",
      suppRepresentativeEmail: ""
    };
    dispatch({ type: "update", field: "inputFields", value: inputs });
    dispatch({ type: "update", field: "errors", value: {} });
  };

  const resetState = () => {
    dispatch({ type: "reset" });
    resetAllInputs();
    resetTableData();
    setHighlightMandatoryFields(null);
    setResetAllVisitedFields(false);
    changeBackgroundColor("processInfoBg");
  };

  useEffect(() => {
    if (resetAllVisitedFields) resetState();
  }, [resetAllVisitedFields]);



  return (
    <>
      <div
        className={clsx(
          styles.scrollContainer,
          styles.formContainer
        )}
      >
        <CustomFormGroup
          header="Booking Efficiency  Report"
          body={renderOther()}
        />
        {myState.tableFlag && tableData.length === 0 && 
        <>{renderReport()}</>
        } 
        {loadings ? (
    <div style={{textAlign:"center",display:"flex",justifyContent:"center",marginTop:"40px"}}>
         <Truckloading />
    </div>):""}

      </div>
      <ResetModal
        isPopupOpen={isPopupOpen}
        handleClose={handleClose}
        resetFields={resetFields}
      />

      <ResetModal2
        a={confirmModalFlag2}
        handleCase={handleClose2}
        onDelete={() => onDeleteRow2(deleteParam2)}
      />
    </>
  );
}

function ResetModal2({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Do you want to delete ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCase}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}
function ResetModal1({ a, handleCase, onDelete }) {
  return (
    <Dialog
      open={a}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox
      }}
      data-testid="reset-popup1"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <DeleteIcon style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Are you sure ?</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Do you want to delete ?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleCase}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={onDelete}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

function ResetModal({ isPopupOpen, handleClose, resetFields }) {
  return (
    <Dialog
      open={isPopupOpen}
      className={styles.popContainer}
      classes={{
        paper: styles.popupBox
      }}
      data-testid="reset-popup"
    >
      <>
        <DialogTitle>
          <span className={styles.title}>
            <MdReplay style={{ height: "18px", width: "18px" }} />
            <span className={styles.txt}>Reset</span>
          </span>
        </DialogTitle>
        <DialogContent className={styles.content}>
          <span>Are you sure you want to reset the filters?</span>
        </DialogContent>
        <DialogActions>
          <Button
            className={clsx(styles.actionButton, styles.transparentButton)}
            onClick={handleClose}
          >
            Cancel
          </Button>
          <Button
            className={clsx(styles.actionButton, styles.primaryActionButton)}
            variant="primary"
            onClick={(e) => {
              e.preventDefault();
              handleClose();
              resetFields();
            }}
          >
            Yes
          </Button>
        </DialogActions>
      </>
    </Dialog>
  );
}

ReportShiftUtilizationForm.propTypes = {
  redirectToProcessPage: PropTypes.func
};

ResetModal.propTypes = {
  isPopupOpen: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  resetFields: PropTypes.func.isRequired
};
ResetModal1.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};
ResetModal2.propTypes = {
  a: PropTypes.bool.isRequired,
  handleCase: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired
};

const mapStateToProps = (state) => ({
  product: state.product,
  counter: state.counter.value,
  baseUrl: state.counter.baseUrl,
  auth: state.auth
});
const mapDispatchToProps = (dispatch) => ({
  fetchChassis: (chassisParam) => dispatch(fetchChassis(chassisParam)),
  getInvoice: (chassisParam) => dispatch(getInvoice(chassisParam))
});
ReportShiftUtilizationForm.propTypes = {
  counter: PropTypes.number,
  baseUrl: PropTypes.string,
  product: PropTypes.object,
  auth: PropTypes.object
};
const App = connect(
  mapStateToProps,
  mapDispatchToProps
)(ReportShiftUtilizationForm);

export default withAllowedOperationsProvider(App, RESOURCE_TYPE.PPAP);